import { FirestoreService } from "./firestoreService";
import { MessageType } from "../../models/message";
import { ProfileType } from "../../models/profileType";

const COLLECTION_NAME = "messages"

export const messageService = {
  sendMessageToUser: async (userId: string, newMessage: MessageType) => {
    await FirestoreService.addDocument(`${COLLECTION_NAME}/${userId}/userMessages`, newMessage); // Nested collection for user messages
  },

  updateMessage: async (userId: string, messageId: string, message: Partial<MessageType>) => {
    await FirestoreService.updateDocument(`${COLLECTION_NAME}/${userId}/userMessages`, messageId, message);
  },

  fetchMessagesByUser: async (profile: ProfileType): Promise<MessageType[]> => {
    try {
      const messages = (await FirestoreService.getCollection(`${COLLECTION_NAME}/${profile.id}/userMessages`)) as MessageType[];
      if (profile.profileType === "staff") {
      return messages
        .filter((msg: MessageType) => msg.isActive)  
        .filter((msg: MessageType) => msg.type !== "refund_request")  
      }
      return messages.filter((msg: MessageType) => msg.isActive)
    } catch (error) {
      console.error("Error fetching messages:", error);
      throw new Error("Failed to fetch messages. Please try again later.");
    }
  },
};
